import { selectResource } from '../resource/resourceSelectors'

export const selectPaymentTypesData = state => selectResource(state)?.paymentTypes?.data || []
